<template>
  <div class="col-md-12 snapshots_list">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="form_select">
          <tree-select
              :options="client_list"
              :multiple="true"
              v-model="filter.client_ids"
              :placeholder="translate('snapshots.client_name')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <tree-select
              :options="status_list"
              :multiple="false"
              v-model="filter.status"
              :placeholder="translate('snapshots.status')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <tree-select
              :options="company_user_list"
              :multiple="false"
              v-model="filter.user_id"
              :placeholder="translate('snapshots.user')"
              :clearable="true"
              @input="change_input"
          />
        </div>
        <div class="form_select">
          <WrapDatePicker
              type="date"
              :placeholder="translate('client_order.period')"
              v-model="filter.date"
              :range="true"
              :confirm="true"
              value_type="YYYY-MM-DD"
              @input="change_input"
          />
        </div>
        <div class="form_select"></div>
      </div>
    </div>

    <div class="response_table" >
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th scope="col" class="">
              {{ translate('snapshots.order_name') }}
            </th>
            <th scope="col" class="">
              {{ translate('snapshots.client_name') }}
            </th>
            <th scope="col" class="">
              {{ translate('snapshots.device') }}
            </th>
            <th scope="col" class="">
              {{ translate('snapshots.user') }}
            </th>
            <th scope="col" class="">
              {{ translate('snapshots.status') }}
            </th>
            <th scope="col" class="">
              {{ translate('snapshots.model_name') }}
            </th>
            <th scope="col" class="">
              {{ translate('snapshots.modems_count') }}
            </th>
            <th scope="col" class="">
              {{ translate('snapshots.created') }}
            </th>   </tr>
        </thead>
        <tbody v-if="snapshots_list.length > 0">
          <SnapshotsListItem
              v-for="(snapshot,key) in snapshots_list"
              :key="key"
              :snapshot="snapshot"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import SnapshotsListItem from "@/views/Dashboard/General/SnapshotList/Item/Index.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'SnapshotsList',
  components: {
    SnapshotsListItem,
    WrapDatePicker
  },
  data () {
    return {
      snapshots_list: [],
      check_link: true,
      filter:{
        status: null,
        client_ids: [],
        user_id: null,
        date: [],
      },
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },

  computed:{
    send_filter(){
      let filter = {}
      Object.keys(this.filter).forEach((key) => {
        if (key === "date"){
          if (this.filter[key][0] && this.filter[key][1]){
            filter['date_start'] = this.filter[key][0]
            filter['date_end'] = this.filter[key][1]
          }
        } else if(key === "client_ids"){
          this.filter[key].length > 0 ? filter[key] = this.filter[key] : ''
        } else{
          if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== "") {
            filter[key] = this.filter[key]
          }
        }
      })
      return filter
    },
    status_list(){
      return this.$store.getters.getSnapshotsInfo.statuses.map((entry) => {
        return {id: entry.id, label: entry.title}
      })
    },
    client_list(){
      return  this.$store.getters.getClientsList.map((client) => {
        return { id: client.id, label: client.name }
      })
    },
    company_user_list(){
      return this.$store.getters.getCompanyUserList.map((user) => {
        return {label: user.name, id: user.id}
      })
    },
  },

  watch:{
    filter:{
      deep: true,
      handler(){
        if (this.$route.name === 'snapshot_list') {
          let string = '?'
          for (let key in this.filter) {
            switch (key) {
              case 'status':
              case 'user_id':
                if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== "") {
                  string += `&${key}=${this.filter[key]}`
                }
                break;

              case 'client_ids':
                if (this.filter[key].length > 0){
                  string += `&${key}=${this.filter[key]}`
                }
                break;

              case 'date':
                if(this.filter[key][0] !== null && this.filter[key][1]){
                  string += '&' + key + '=' + this.filter[key]
                }
            }
          }
          history.pushState(null, null, this.$route.path + string)
        }
      }
    }
  },

  activated () {
    this.check_query()
    this.load_snapshots_list()
  },

  methods: {
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.load_snapshots_list, 500)
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'status':
            case 'user_id':
              this.filter[key] = this.$route.query[key]
              break;

            case 'client_ids':
              this.filter[key] = this.$route.query[key].split(',').map(item => {
                return Number(item)
              })
              break;

            case 'date':
              this.filter[key] = this.$route.query[key].split(',').map(item => {
                return item
              })
              break;
          }
        }
        // this.check_query()
      }
    },

    load_snapshots_list(){
      this.$http.v1.getSnapshotList(this.send_filter, (response) => {
        if (response.data){
          this.snapshots_list = response.data
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  }
}
</script>

<style lang="scss" scoped>

.snapshots_list{
  height: 100%;
  display: flex;
  flex-direction: column;
  .main_filters{
    top: 20px;
  }

  .header{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex: 1;
    & > *{
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
    .filter{
      margin: 0;
    }
    .form{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 2;

      .search_user{
        margin-bottom: 0;
        width: 100%;
      }
      .btn{
        width: 30%;
      }
    }
    .form_select{
      flex: 1;
      .vue-treeselect{
        margin-bottom: 0;
      }
    }
  }

  .client_order{
    cursor: pointer;
    &:hover{
      background-color: #eee;
    }
    td{
      overflow: hidden;
    }
  }
  .response_table{
    flex: 10;
    padding-left: 0;
    padding-right: 0;
    tbody{
      cursor: pointer;
      color: #252422;
      tr{
        &:hover{
          background-color: #eee;
        }
      }
    }
    .level{
      display: inline-block;
      width: 20px;
      height: 100%;
    }
    .w180{
      max-width: 180px;
      width: 180px;
    }
    .w100{
      max-width: 100px;
      width: 100px;
    }
    .has_child{
      background-color: #eee;
      font-weight: bold;
    }
    .name{
      text-align: left;
    }
    .inn{
      text-align: left;
    }
  }
}

@media (max-width: 1200px) {
  .snapshots_list{
    .response_table{
      .w180{
        max-width: none;
        width: auto;
      }
      .w100{
        max-width: none;
        width: auto;
      }
    }
  }
}

@media (max-width: 500px){
  .header{
    .form{
      width: 100%;
      .filter{
        min-width: max-content;
        margin: 0 10px;
      }
    }
    .btn{
      b{
        display: none;
      }
      width: 20%;
      min-width: inherit;
    }
    .search_user{
      width: 80%;
    }
  }

}
</style>
